<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CatalogueLive
        code="mode_paiement"
        v-model="sasInscriptionTableau.modeDePaiement"
        :live="liveSasInscriptionTableau(7715)"
      />
      <ressource code="info-interac" v-if="!conditionDeclarationFraisTransaction" />
      <CaseACocherLive
        code="declaration-frais-transaction"
        v-model="sasInscriptionTableau.declarationFraisDeTransaction"
        :live="liveSasInscriptionTableau(7716)"
        :opqIf="conditionDeclarationFraisTransaction"
      />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import { mapActions } from "vuex"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object },
    endpoint: { type: String },
  },
  watch: {
    "sasInscriptionTableau.modeDePaiement"() {
      this.updatePanier()
    },
  },
  computed: {
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    },
    conditionDeclarationFraisTransaction() {
      return this.getCatalogueCodeById("7715", this.sas.sasInscriptionTableau.modeDePaiement) === "moneris"
    },
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: this.endpoint, sasId: this.sas.id })
    },
    liveSasInscriptionTableau(cle) {
      return { endpoint: "sas-inscription-tableau", cle: cle, fileId: this.sasInscriptionTableau.id }
    },
  },
}
</script>

<style></style>
